const R = require('ramda')

const installPage = require('./page/installClient')

module.exports = R.pipe(
  installPage,
)
